import Component from 'classes/Component'
import GSAP from 'gsap'

export default class Button extends Component {
  constructor() {
    super({
      element: '.button',
      elements: {

      }
    })

    this.buttons = document.querySelectorAll('[data-animation="button"]')

    this.createInteractions()
  }

  buttonHover = (button) => {
    this.currentButton = button.srcElement

    this.currentButton.classList.add('button_hover')

    this.currentButton.addEventListener('mouseleave', this.buttonOut)
  }

  buttonOut = () => {
    this.currentButton.classList.remove('button_hover')

    GSAP.to(this.currentButton, {
      autoAlpha: 1
    })
  }

  createInteractions = () => {
    this.buttons.forEach((button) => {
      button.addEventListener('mouseenter', this.buttonHover)
    })
  }
}
